export default "__VITE_ASSET__DQRURqeX__"